<template>
    <div class="container">
        <form class="form-signin">
            <h2 class="form-signin-heading">Please sign in</h2>
            <label for="inputEmail" class="sr-only">Email address</label>
            <input type="email" v-model="email" id="inputEmail" class="form-control" placeholder="Email address" required autofocus>
            <label for="inputPassword" class="sr-only">Password</label>
            <input type="password" v-model="password" id="inputPassword" class="form-control" placeholder="Password" required>
            <div class="checkbox"></div>
            <button @click.prevent="login(email, password)" class="btn btn-lg btn-primary btn-block">Sign in</button>
        </form>
    </div>
</template>

<script>
    import firebase from 'firebase'
    import { eventBus } from '../../main'

    export default {
        data() {
            return {
                email: '',
                password: '',
            }
        },
        methods: {
            login: function(email, password) {
                var self = this;
                firebase.auth().signInWithEmailAndPassword(email, password).then(
                    function(data) {
                        firebase.auth().onAuthStateChanged(user => {
                            if (user) {
                                eventBus.$emit('loggedIn', true);
                                self.$router.push({
                                    name: 'offersList'
                                })
                            }
                        });
                    }
                ).catch(function(error) {
                    alert(errorMessage);
                    var errorCode = error.code;
                    var errorMessage = error.message;
                });
            }
        }
    }
</script>

<style scoped>
    body {
        padding-top: 40px;
        padding-bottom: 40px;
        background-color: #fafafa;
    }
    
    .form-signin {
        max-width: 330px;
        padding: 15px;
        margin: 0 auto;
    }
    
    .form-signin .form-signin-heading,
    .form-signin {
        margin-bottom: 10px;
    }
    
    .checkbox {
        margin-top: 25px;
    }
    
    .form-signin .checkbox {
        font-weight: normal;
    }
    
    .form-signin .form-control {
        position: relative;
        height: auto;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 10px;
        font-size: 16px;
    }
    
    .form-signin .form-control:focus {
        z-index: 2;
    }
    
    .form-signin input[type="email"] {
        margin-bottom: -1px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }
    
    .form-signin input[type="password"] {
        margin-bottom: 10px;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }
</style>


// WEBPACK FOOTER //
// Login.vue?da6ed35a